import { DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TreeNode } from '../../model/tree-node';

@Component({
  selector: 'app-tree-item-badge',
  templateUrl: './tree-item-badge.component.html',
  styleUrls: [ './tree-item-badge.component.scss' ],
  imports: [ DecimalPipe ]
})
export class TreeItemBadgeComponent {
  @Input() item: TreeNode;
  @Input() visible = true;
}
